import ProductCardSkeleton from "@/components/catalog/ProductCardSkeleton";
import { Skeleton } from "@/components/ui/skeleton";

const FeaturedProductsSkeleton = () => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <Skeleton className="h-10 w-64 mx-auto mb-4" />
          <Skeleton className="h-6 w-96 mx-auto max-w-full" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {Array.from({ length: 4 }).map((_, i) => (
            <ProductCardSkeleton key={i} />
          ))}
        </div>

        <div className="text-center">
          <Skeleton className="h-12 w-48 mx-auto rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default FeaturedProductsSkeleton;
